module.exports = __webpack_public_path__ + "static/img/t3.564453d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t3.jpg
// module id = VgLY
// module chunks = 1